module.exports = global.config = {
    server_url: "https://server.weddingsbydhruva.com/dhruvaserver/weddings_by_dhruva/", 
    // server_url: "http://localhost:3001/dhruvaserver/weddings_by_dhruva/",
};